var OldSoundManager = window.OldSoundManager = function (fallback, callback) {
	this.ready = false;
	this.sounds = {};
	
	this.context = {
		get currentTime() {
			return Date.now() / 1000;
		},
	};
	
	if (fallback === 'slot') {
		fallback = {
			// button: [ 0, 0.444 ],
			spin: [ 45.362, 0.640 ],
			win: {
				win_1:    [  1, 1.619 ],
				win_2:    [  3, 3.004 ],
				win_3:    [  7, 5.093 ],
				bigwin_1: [ 13, 6.608 ],
				bigwin_2: [ 19, 5.799 ],
				bigwin_3: [ 27, 5.799 ],
			},
			buttons: {
				auto:   [ 39.620, 0.276 ],
				denom:  [ 40.000, 0.5 ],
				menu2:  [ 40.600, 0.218 ],
				help:   [ 40.802, 0.349 ],
				max:    [ 41.684, 1.120 ],
				lobby:  [ 43.219, 0.407 ],
				menu:   [ 43.719, 0.204 ],
				recall: [ 43.966, 0.378 ],
				sound:  [ 44.500, 0.5 ],
				spin:   [ 45.362, 0.640 ],
				autos: {
					auto_0: [ 46.000, 0.287 ],
					auto_1: [ 46.290, 0.313 ],
					auto_2: [ 46.600, 0.313 ],
					auto_3: [ 46.916, 0.313 ],
					auto_4: [ 47.229, 0.313 ],
					auto_5: [ 47.543, 0.313 ],
					auto_6: [ 47.856, 0.144 ],
				},
				coins: {
					bet_0: [ 48.486, 0.627 ],
					bet_1: [ 49.113, 0.627 ],
					bet_2: [ 49.740, 0.627 ],
					bet_3: [ 50.367, 0.627 ],
					bet_4: [ 50.993, 0.627 ],
					bet_5: [ 51.620, 0.627 ],
				},
				denoms: {
					denom_0: [ 52.247, 0.313 ],
					denom_1: [ 52.656, 0.470 ],
					denom_2: [ 53.030, 0.731 ],
					denom_3: [ 53.762, 1.202 ],
					denom_4: [ 55.128, 1.750 ],
					denom_5: [ 56.878, 0.862 ],
					denom_6: [ 57.740, 0.862 ],
				},
				lines: {
					line_0: [ 58.602, 0.287 ],
					line_1: [ 58.890, 0.287 ],
					line_2: [ 59.177, 0.261 ],
					line_3: [ 59.438, 0.235 ],
					line_4: [ 59.673, 0.235 ],
					line_5: [ 59.910, 0.235 ],
				},
			},
			reels: [ 34, 0.261 ],
			bell:  [ 35, 4.362 ],
		};
	}
	
	if (fallback === 'bingo') {
		fallback = {
			// button: [ 0, 0.444 ],
			win: {
				win_1:    [  1, 1.619 ],
				win_2:    [  3, 3.004 ],
				win_3:    [  7, 5.093 ],
				bigwin_1: [ 13, 6.608 ],
				bigwin_2: [ 19, 5.799 ],
				bigwin_3: [ 27, 5.799 ],
			},
			
			ball:  [ 34.15, 0.182 ],
			deal:  [ 35.00, 1.097 ],
			extra: [ 37.00, 3.840 ],
			
			buttons: {
				auto:   [ 41.000, 0.200 ],
				denom:  [ 41.750, 0.200 ],
				menu2:  [ 42.000, 0.338 ],
				lobby:  [ 42.441, 0.270 ],
				max:    [ 43.300, 1.100 ],
				help:   [ 44.850, 0.301 ],
				menu:   [ 45.129, 0.200 ],
				recall: [ 45.500, 0.323 ],
				sound:  [ 46.200, 0.361 ],
				spin:   [ 46.964, 0.579 ],
				denoms: {
					denom_0: [ 47.543, 0.313 ],
					denom_1: [ 47.856, 0.470 ],
					denom_2: [ 48.327, 0.731 ],
					denom_3: [ 49.058, 1.202 ],
					denom_4: [ 50.260, 1.750 ],
					denom_5: [ 52.010, 0.862 ],
					denom_6: [ 52.872, 0.862 ],
				},
				coins: {
					bet_0: [ 53.734, 0.627 ],
					bet_1: [ 54.361, 0.627 ],
					bet_2: [ 54.988, 0.627 ],
					bet_3: [ 55.615, 0.627 ],
					bet_4: [ 56.242, 0.627 ],
					bet_5: [ 56.869, 0.627 ],
				},
			},
			spin: [ 46.964, 0.579 ],
		};
	}
	
	if (fallback === 'poker') {
		fallback = {
			win: {
				win_1:    [  1, 1.619 ],
				win_2:    [  3, 3.004 ],
				win_3:    [  7, 5.093 ],
				bigwin_1: [ 13, 6.608 ],
				bigwin_2: [ 19, 5.799 ],
				bigwin_3: [ 27, 5.799 ],
			},
			
			card: [ 34, 0.200 ],
			hold: [ 35, 0.200 ],
			done: [
				[ 36, 0.548 ],
				[ 37, 0.548 ],
				[ 38, 0.548 ],
			],
			feature: {
				spin:     [ 40, 3.840 ],
				activate: [ 45, 0.731 ],
			},
			buttons: {
				denom:  [ 46.500, 0.365 ],
				menu2:  [ 47.000, 0.281 ],
				help:   [ 47.338, 0.365 ],
				max:    [ 48.000, 1.224 ],
				lobby:  [ 49.743, 0.415 ],
				menu:   [ 50.100, 0.232 ],
				recall: [ 50.456, 0.348 ],
				sound:  [ 51.000, 0.400 ],
				spin:   [ 51.883, 0.597 ],
				coins: {
					bet_0: [ 52.480, 0.627 ],
					bet_1: [ 53.107, 0.627 ],
					bet_2: [ 53.734, 0.627 ],
					bet_3: [ 54.361, 0.627 ],
					bet_4: [ 54.988, 0.627 ],
					bet_5: [ 55.615, 0.627 ],
				},
				denoms: {
					denom_0: [ 56.242, 0.313 ],
					denom_1: [ 56.555, 0.470 ],
					denom_2: [ 57.025, 0.731 ],
					denom_3: [ 57.757, 1.202 ],
					denom_4: [ 58.958, 1.750 ],
					denom_5: [ 60.710, 0.862 ],
					denom_6: [ 61.571, 0.862 ],
				},
			},
			spin: [ 51.883, 0.597 ],
		};
	}
	if (fallback === 'keno') {
		fallback = {
		//	draw: [ 0, 0.5 ],
			buttons: {
				miss: [ 0.50, 0.3 ],
				quick: [ 0.80, 1.30 ],
				max: [ 2.10, 1.64 ],
				denom: [ 4, 1.43 ],
				clear: [ 5.5, 1.69 ],
				denom: [ 7.50, 1.43 ],
				cash_flag:  [ 9, 1.25 ],
				bet_up: [ 10.5, 1.41 ],
				bet_down: [ 12, 1.3 ],
				speeds: {
					speed1: [ 13.5, 2 ],
					speed2: [ 15.54, 1.93 ],
					speed3: [ 17.48, 1.98 ],
					speed4: [ 19.46, 2 ],
					speed5: [ 21.5, 2 ],
				},
			},
		};
	}
	
	if (typeof fallback !== 'object') {
		console.log('Unknown fallback. Sounds not loaded.');
		
		return callback && callback(false);
	}
	
	this.fallback = fallback;
	
	var src = fallback._;
	
	if (!src) {
		src = OldSoundManager.base + 'sounds/fallback';
	}
	
	this.callback = callback;
	this.base = '';
	
	this.sounds._ = new Audio();
	
	if (this.sounds._.canPlayType('audio/mpeg')) {
		src += '.mp3';
	}
	
	else {
		console.log('MP3 playback is not supported by your browser.');
		callback(false);
		
		return;
	}
	
	this.sounds._.src = src;
	this.sounds._start = 0;
	this.sounds._stop = 0;
	
	var that = this;
	$(this.sounds._).on('progress', function() {
		that.ready = true;
		that.callback(1);
	});
	
	setInterval(function() {
		if (!that.sounds._.paused && that.sounds._.currentTime > that.sounds._stop) {
			if (that.sounds._loop) {
				that.sounds._.currentTime = that.sounds._start;
			}
			
			else {
				that._stop();
			}
		}
	}, 100);
	
	this.ready = true;
	
	if (this.callback) {
		this.callback(1);
	}
};

OldSoundManager.base = '';

OldSoundManager.prototype.loadSounds = function() {
	// OldSoundManager does not support loading additional sounds.
};

OldSoundManager.prototype.setFallback = function(base, fallbackData) {
	var srcCheck = base + 'sounds/' + fallbackData._ + '.mp3';
	
	this.fallback = fallbackData;
	this.sounds._.src = srcCheck;
};

OldSoundManager.prototype._play = function(info, options) {
	if (!options) {
		options = { };
	}
	
	if (typeof options === 'number') {
		options = { time: options };
	}
	
	if (typeof options === 'boolean') {
		options = { loop: options };
	}
	
	this.sounds._.pause();
	this.sounds._start = info[ 0 ];
	this.sounds._stop = info[ 0 ] + info[ 1 ];
	
	if (this.sounds._.currentTime > 0) {
		this.sounds._.currentTime = this.sounds._start || 0;
	}
	
	else {
		if (this.sounds._start !== 0) {
			this.sounds._stop = 0;
		}
	}
	
	if (options.loop) {
		this.sounds._loop = true;
	}
	
	else {
		this.sounds._loop = false;
	}
	
	var that = this;
	var go = function() {
		that.sounds._.play();
	};
	
	if (options.time) {
		setTimeout(go, options.time);
	}
	
	else {
		go();
	}
};

OldSoundManager.prototype._stop = function(info, options) {
	if (!info || (this.sounds._.currentTime > info[ 0 ] && this.sounds._.currentTime < info[ 0 ] + info[ 1 ])) {
		if (!options) {
			options = { };
		}
		
		if (typeof options === 'number') {
			options = { time: options };
		}
		
		var that = this;
		var go = function() {
			that.sounds._loop = false;
			that.sounds._.pause();
		};
		
		if (options.time) {
			setTimeout(go, options.time);
		}
		
		else {
			go();
		}
	}
};

OldSoundManager.prototype._source = function(path) {
	var source = this.fallback;
	
	for (var p = 0; p < path.length; p++) {
		if (!source[ path[ p ] ]) {
			if (typeof path[ p ] === 'number') {
				return source;
			}
			
			else {
				return null;
			}
		}
		
		source = source[ path[ p ] ];
	}
	
	return source;
};

OldSoundManager.prototype.fade = function(path /* , from, to, time */) {
	this.stop(path);
};

OldSoundManager.prototype.play = function(path, options) {
	if (!this.ready) {
		return;
	}
	
	if (typeof path === 'string') {
		path = [ path ];
	}
	
	var info = this._source(path);
	
	if (!info) {
		return null;
	}
	
	else if (info.constructor === Object && typeof path[ path.length - 1 ] === 'number') {
		for (var k in info) {
			if (path[ path.length - 1 ] >= k) {
				info = info[ k ];
				break;
			}
		}
	}
	
	if (info.constructor !== Array || info.length !== 2) {
		throw new Error('Incorrect sound configuration: ' + path.join());
	}
	
	this._play(info, options);
	
	return {
		buffer: { duration: info[ 1 ] },
	};
};

OldSoundManager.prototype.stop = function(path, options) {
	if (!this.ready) {
		return;
	}
	
	if (typeof path === 'string') {
		path = [ path ];
	}
	
	var info = this._source(path);
	
	this._stop(info, options);
	
	return this;
};

OldSoundManager.prototype.volume = function(value) {
	this.sounds._.volume = value;
};



/** WEBPACK FOOTER **
 ** ./../../../../engine/public-src/common/sound/sound-fallback.js
 **/